import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Watchlist } from 'src/app/models/watchlist';
import { WatchlistRecord } from 'src/app/models/watchlistRecord';
import { ConstantsStore } from '../constants.store';
import { CACHE_KEY } from '../interceptors/cache-header.interceptor';
import {RenameModel} from '../../../models/renameModel';
import {tap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class WatchlistsService {

  userWatchlists: Watchlist[];

  constructor(
    private constants: ConstantsStore,
    private http: HttpClient
  ) { }

  getUserWatchlists(): Observable<Watchlist[]> {
    return this.httpGet()
      .pipe(
        tap(watchlists => {
          this.userWatchlists = [...watchlists];
        })
      );
  }

  addWatchlist(watchlistName: string) {
    return new Observable(observer => {
      this.httpPost(watchlistName)
      .subscribe(
        (watchlistId: number) => observer.next(watchlistId),
        error => observer.error(error)
      );
    });
  }

  updateWatchlistStatus(watchlistId: number) {
    return new Observable(observer => {
      this.httpPut(watchlistId)
      .subscribe(
        () => observer.next(),
        error => observer.error(error)
      );
    });
  }

  httpPatchNameWatchlist(watchlist: RenameModel) {
    return this.http.patch(`${this.constants.watchlistManagementUrl}/${watchlist.id}`, watchlist);
  }

  deleteWatchlist(watchlistId: number) {
    return new Observable(observer => {
      this.httpDelete(watchlistId)
      .subscribe(
        () => observer.next(),
        error => observer.error(error)
      );
    });
  }

  private httpGet() {
    const getHeaders = { [CACHE_KEY]: '1' };
    return this.http.get<Watchlist[]>(this.constants.watchlistManagementUrl, { headers: getHeaders });
  }
  private httpPost = (watchlistName: string) => this.http.post(`${this.constants.watchlistManagementUrl}/${watchlistName}`, {});
  private httpPut = (watchlistId: number) => this.http.put(`${this.constants.watchlistManagementUrl}/${watchlistId}`, {});
  private httpDelete = (watchlistId: number) => this.http.delete(`${this.constants.watchlistManagementUrl}/${watchlistId}`);

  getWatchlistContent(watchlistId: number) {
    return new Observable<WatchlistRecord[]>(observer => {
      this.httpGetContent(watchlistId)
      .subscribe(
        watchlistContent => {
          observer.next([...watchlistContent]);
        },
        error => observer.error(error)
      );
    });
  }

  addCertificate(watchlistId: number, certificates: string[]) {
    return new Observable(observer => {
      this.httpPostContent(watchlistId, certificates)
      .subscribe(
        () => observer.next(),
        error => observer.error(error)
      );
    });
  }

  canAddCertificate(watchlistId: number, certificate: string) {
    return this.http.get<boolean>(`${this.constants.watchlistManagementUrl}/${watchlistId}/can-add/${certificate}`);
  }

  deleteCertificate(watchlistId: number, certificateIsin: string) {
    return new Observable(observer => {
      this.httpDeleteContent(watchlistId, certificateIsin)
      .subscribe(
        () => observer.next(),
        error => observer.error(error)
      );
    });
  }


  private httpGetContent(watchlistId: number) {
    const getHeaders = { [CACHE_KEY]: '1' };
    return this.http.get<WatchlistRecord[]>(`${this.constants.watchlistUrl}/${watchlistId}`, { headers: getHeaders });
  }
  private httpPostContent = (watchlistId: number, certificates: string[]) => this.http.post(`${this.constants.watchlistUrl}/${watchlistId}`, certificates);
  private httpDeleteContent = (watchlistId: number, certificateIsin: string) => this.http.delete(`${this.constants.watchlistUrl}/deleteisin/${watchlistId}/${certificateIsin}`);

}
